import type { TypographyOptions } from '@mui/material/styles/createTypography';

export const typography = {
  fontFamily:
    '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "SF Pro Display", "SF Pro Text", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
  body1: { 
    fontSize: '1rem', 
    fontWeight: 400, 
    lineHeight: 1.6,
    letterSpacing: '0.01em',
  },
  body2: { 
    fontSize: '0.875rem', 
    fontWeight: 400, 
    lineHeight: 1.6,
    letterSpacing: '0.01em',
  },
  button: { 
    fontWeight: 600,
    letterSpacing: '0.02em',
    textTransform: 'none' as const,
  },
  caption: { 
    fontSize: '0.75rem', 
    fontWeight: 400, 
    lineHeight: 1.5,
    letterSpacing: '0.02em',
  },
  subtitle1: { 
    fontSize: '1rem', 
    fontWeight: 600, 
    lineHeight: 1.5,
    letterSpacing: '0.01em',
  },
  subtitle2: { 
    fontSize: '0.875rem', 
    fontWeight: 600, 
    lineHeight: 1.5,
    letterSpacing: '0.01em',
  },
  overline: {
    fontSize: '0.75rem',
    fontWeight: 600,
    letterSpacing: '0.08em',
    lineHeight: 2.2,
    textTransform: 'uppercase' as const,
  },
  h1: { 
    fontSize: '3.5rem', 
    fontWeight: 700, 
    lineHeight: 1.1,
    letterSpacing: '-0.02em',
  },
  h2: { 
    fontSize: '3rem', 
    fontWeight: 700, 
    lineHeight: 1.1,
    letterSpacing: '-0.01em',
  },
  h3: { 
    fontSize: '2.25rem', 
    fontWeight: 700, 
    lineHeight: 1.2,
    letterSpacing: '-0.01em',
  },
  h4: { 
    fontSize: '2rem', 
    fontWeight: 600, 
    lineHeight: 1.2,
    letterSpacing: '0em',
  },
  h5: { 
    fontSize: '1.5rem', 
    fontWeight: 600, 
    lineHeight: 1.3,
    letterSpacing: '0em',
  },
  h6: { 
    fontSize: '1.125rem', 
    fontWeight: 600, 
    lineHeight: 1.4,
    letterSpacing: '0.01em',
  },
} satisfies TypographyOptions;
